import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import f from 'odata-filter-builder';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HierarchyLeaderService } from 'services/corporate/hierarchyLeader.service';
import { EmployeeModel } from 'services/models/employee.model';
import { FeedbackFormComponent, FeedbackFormMode } from 'app/views/shared/feedback/components/feedback-form/feedback-form.component';

const timeSearch = 1000;

@Component({
    selector: 'app-manager-hierarchy',
    templateUrl: './manager-hierarchy.component.html',
    styleUrls: ['./manager-hierarchy.component.scss'],
})
export class ManagerHierarchyComponent implements OnInit, OnDestroy {
    public title = 'Sua equipe';
    public list: EmployeeModel[] = [];
    public count = 0;
    public isLoading = false;
    public currentSort = { prop: 'creationDate', dir: 'asc' };
    public filters = { searchQuery: '' };
    private searchSubject = new Subject<string>();
    private subscriptions = new Subscription();

    public columns = [
        { name: 'Nome', prop: 'name', action: 'avatar' },
        { name: 'Matrícula', prop: 'registration' },
        { name: 'Ação', action: 'create' },
    ];

    queryParams: any = {
        top: 10,
        skip: 0,
        page: 1,
        filter: null,
        orderBy: 'id',
        orderByOrder: 'asc',
        select: [],
    };

    constructor(
        private hierarchyLeaderService: HierarchyLeaderService,
        private ngbModal: NgbModal
    ) { }

    ngOnInit(): void {
        this.loadFeedbacks();
        this.subscriptions.add(
            this.searchSubject.pipe(debounceTime(timeSearch)).subscribe(() => this.applyFilters())
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    onSearchQueryChange(): void {
        this.searchSubject.next(this.filters.searchQuery || '');
    }

    clearSearch(): void {
        this.filters.searchQuery = '';
        this.applyFilters();
    }

    applyFilters(): void {
        const filters: string[] = [];
        if (this.filters.searchQuery) {
            const search = this.filters.searchQuery.toLocaleLowerCase();
            filters.push(
                `(${f().contains('tolower(name)', search).toString()} or ${f()
                    .contains('tolower(registration)', search)
                    .toString()})`
            );
        }
        this.queryParams.skip = 0;
        this.queryParams.page = 1;
        this.queryParams.filter = filters.length ? `&$filter=${filters.join(' and ')}` : null;
        this.loadFeedbacks();
    }

    loadFeedbacks(): void {
        this.isLoading = true;
        const homeSelect = ['registration', 'name', 'id', 'enable', 'creationDate'];
        this.queryParams.select = homeSelect;

        this.hierarchyLeaderService.listEmployeesByHierarchy(this.queryParams).subscribe({
            next: res => {
                this.list = res.data || [];
                this.count = res.count || 0;
                this.isLoading = false;
            },
            error: () => {
                this.list = [];
                this.count = 0;
                this.isLoading = false;
            },
        });
    }

    onSort(event: any): void {
        if (event?.sorts?.length) {
            const [sort] = event.sorts;
            this.currentSort = { prop: sort.prop, dir: sort.dir === 'desc' ? 'desc' : 'asc' };
            this.queryParams.orderBy = sort.prop;
            this.queryParams.orderByOrder = this.currentSort.dir;
            this.loadFeedbacks();
        }
    }

    onPage(event: any): void {
        this.queryParams.skip = event.offset * event.limit;
        this.queryParams.top = event.limit;
        this.loadFeedbacks();
    }

    handleCreateFeedback(employee: EmployeeModel): void {
        const modalRef = this.ngbModal.open(FeedbackFormComponent, {
            animation: false,
            windowClass: 'feedback-form-drawer-modal',
            backdropClass: 'feedback-form-drawer-modal-backdrop',
            backdrop: 'static',
            keyboard: true,
            size: 'xl',
        });
        modalRef.componentInstance.mode = FeedbackFormMode.Create;
        modalRef.componentInstance.employee = employee;
        modalRef.result.then(
            (result: boolean) => { if (result) this.loadFeedbacks(); },
            (reason: boolean) => { if (reason) this.loadFeedbacks(); }
        );
    }
}
